export const ActionTypes = {
    FETCH_CONFIG:'FETCH_CONFIG',
    FETCH_CONFIG_FULFILLED:'FETCH_CONFIG_FULFILLED',
    FETCH_CONFIG_PENDING:'FETCH_CONFIG_PENDING',
    FETCH_CONFIG_REJECTED:'FETCH_CONFIG_REJECTED',
};